<template lang="pug">
v-sheet.py-16.px-2.px-sm-8.px-md-16.d-flex.align-center(
  color="primary lighten-5"
)
  v-container(fluid)
    v-row(justify="center" align="center")
      v-col(cols="auto")
        h3.mt-4.mb-8.mb-sm-14.ibm.text-h4.text-md-h3.primary--text Planos para cada fase do seu negócio!
        v-item-group(
          v-model="selectedPlan"
          active-class="plan-card--active"
          mandatory
        )
          v-row(justify="center" align="center")
            v-col(v-for="card in cards" cols="auto" :key="card.id")
              v-item(v-slot="{ active, toggle }")
                v-card.rounded-lg.py-4(
                  :color="active ? 'primary' : ''"
                  outlined
                  style="border: 1px solid #757575"
                  max-width=272
                  max-height=316
                  :min-width="minCardWidth"
                  @click="toggle"
                )
                  v-responsive(:aspect-ratio="cardAspectRatio")
                    v-container
                      v-row(align="center" justify="center")
                        //- v-col(cols="auto")
                        //-   v-img.mb-2(:src="card.image" width=144 height=144)
                        //-     template(#placeholder)
                        //-       v-sheet.rounded-circle(color="grey lighten-4" width=144 height=144)
                        v-col(cols="auto")
                          h6.mb-3.text-center.text-h6.ibm(
                            :class="{ 'primary--text': !active, 'grey--text': active, 'text--lighten-4': active }"
                          ) {{ card.title }}
                          .mb-md-8.text-body-1.heebo(
                            :class="{ 'grey--text': active, 'text--lighten-4': active }"
                          ) {{ card.subtitle }}
                          //- v-btn.px-md-16.heebo.text-none(
                          //-   height=48
                          //-   outlined
                          //-   color="primary accent-2"
                          //- ) Ir para o site
        v-row(justify="center" align="center")
          v-col(cols=12 md="auto")
            v-btn.mt-4.mt-md-8.px-md-16.heebo.text-body-1.font-weight-medium.text-none(
              color="primary accent-2"
              depressed
              :block="$vuetify.breakpoint.smAndDown"
              :min-width="$vuetify.breakpoint.smAndUp ? 368 : 'auto'"
              height=56
            ) Tudo pronto!
</template>

<script>
export default {
  components: {},
  data() {
    return {
      selectedPlan: null,
      cards: [
        {
          id: 0,
          image: '',
          cardColor: 'white',
          title: 'Plano básico',
          subtitle: 'Descrição do plano',
          action: () => {}
        },
        {
          id: 1,
          image: '',
          cardColor: 'white',
          title: 'Plano business',
          subtitle: 'Plano básico + outros',
          action: () => {}
        },
        {
          id: 2,
          image: '',
          cardColor: 'primary',
          title: 'Plano professional',
          subtitle: 'Plano business + outros',
          action: () => {}
        },
        {
          id: 2,
          image: '',
          cardColor: 'primary',
          title: 'Plano enterprise',
          subtitle: 'Contacte-nos!',
          action: () => {}
        }
      ]
    }
  },
  computed: {
    minCardWidth() {
      if (this.$vuetify.breakpoint.xsOnly) return '86vw'
      return '20vw'
    },
    cardAspectRatio() {
      if (this.$vuetify.breakpoint.xsOnly) return 16 / 9
      return 0.85
    }
  }
}
</script>

<style lang="sass" scoped>
.plan-card--active
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)
</style>
